module.exports = __webpack_public_path__ + "static/media/squared.7db753c2.jpg";